<template>
  <div class="panel-content" v-if="currItem.screen_text">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>

    <div class="panel-content-artical">
      <p v-for="(item, index) in currItem.top_screen_text" :key="index" v-html="item.content"></p>
    </div>
    <div class="panel-content-questions">
      <div
        v-for="(ques, quesIndex) in currItem?.questions"
        :key="ques.index"
        class="question-item-con"
      >
        <div class="question-item-stem">
          <span class="stem-index">{{ ques.is_example ? $('hsk_example') : ques.index }}.</span>
          <div v-html="ques.screen_text[0].content" class="stem-text"></div>
        </div>

        <el-input
          v-if="isExamMode"
          :placeholder="$t('subjective_reading_placeholder')"
          v-model="inputArr[quesIndex]"
          maxlength="20"
          @focus="focusQuestion(ques)"
          @input="textInput(inputArr[quesIndex], ques, quesIndex)"
          class="inputTitle"
          clearable
          :id="ques.id"
        >
        </el-input>
        <div v-else class="input-box">
          {{ inputArr[quesIndex] }}
        </div>

        <div class="panel-content-result" v-if="!isExamMode">
          <!-- <div class="mark-score-con">
            {{ $t('evaluate_common_total_score') }}:
            {{ ques?.scores === null ? '-' : ques.scores }}/{{ ques.score }}
          </div> -->
          <p class="orange">{{ $t('hsk_reference_answer') }}</p>
          <p class="correct-answer">
            {{ ques.evaluate.standard_answer[0] }}
          </p>
        </div>
        <div class="correct-box" v-if="!isExamMode && analysisText">
          <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
          <p class="correct-box-answer">
            {{ analysisText }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionDescription from '@/components/hsk/questionDescription'
import { getAllWordsLength } from '@/utils/utils'
import { debugIntegration } from '@sentry/vue'

export default {
  components: { QuestionDescription },
  data() {
    return {
      inputText: '',
      inputTitle: '',
      askList: [],
      blankNum: 0,
      inputTextResult: [],
      inputArr: ['', '', '', '', '', '', ''],
      inputIndex: 0,
    }
  },
  computed: {
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    computedSome() {
      let inputTextNumber = this.inputTextResult.length
        ? this.inputTextResult?.reduce(function (a, b) {
            return a + b
          })?.length
        : 0
      return this.inputTitle?.length + inputTextNumber
    },
    answerText() {
      return this.currItem.evaluate.standard_answer[0].split('\n')
    },
    analysisText() {
      return this.currItem.analysis[this.language]
        ? this.currItem.analysis[this.language]
        : this.currItem.analysis['zh']
    },
    limitLength() {
      return 500 + this.blankNum
    },
    wordLength() {
      return getAllWordsLength(this.inputText)
    },
  },
  watch: {
    currItem: {
      handler(val) {
        if (val && val.index) {
          console.log('val===', val)
          // 将回答过的答案回显到input中
          val.questions.map((item, index) => {
            let inputVal = ''
            if (typeof this.currItem.answer == 'object') {
              inputVal = this.currItem?.answer[index]
            }

            this.inputArr[index] = inputVal
            item.id = 'input_' + item.index
            if (!this.isExamMode) {
              return
            }
            // 点击题目的input框，会导致currItem变更，重新渲染，无focus效果
            // 此处获取题号，手动focus

            if (this.currItem.index == item.index) {
              this.inputIndex = index
              this.$nextTick(() => {
                let inputEl = document.getElementById(item.id)
                inputEl.focus()
              })
            }
          })
        }
      },
      immediate: true,
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    focusQuestion(question) {
      console.log('focusQuestionnnnnnnnnnn')
      if (this.currItem.index !== question.index) {
        //点击其他题目序号的情况
        console.log(this.inputArr[this.inputIndex], 'this.inputArr[this.inputIndex]')
        // 保存当前答案
        let presentInput = this.inputArr[this.inputIndex]
        // 通知切换题号
        this.$emit('focusQuestion', question.index)
      }
    },
    blurInput(e, question, index) {
      console.log('blur')
      console.log(this.inputArr[index], 'this.inputArr[index]')
      console.log(e, question, index)
      if (question.is_example) {
        return
      }
      if (!this.isExamMode) {
        return
      }
      if (e && e !== '') {
        console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
        let inputText = e.replace(/\ +/g, '')

        let ansObj = {
          questionId: this.currItem.index,
          answer: inputText,
          judge: 0,
          scores: null,
          segmentCode: this.currItem.segment_code,
          partCode: this.currItem.part_code,
          ifGroup: this.currItem.ifGroup,
          topic_type: this.currItem.topic_type,
        }
        console.log('我要提交啦!!!!!!!!!!!!', ansObj)
        //选中后延时1ms再提交
        setTimeout(() => {
          this.$emit('saveRes', ansObj)
        })
      }
    },
    textInput(e, question, index) {
      if (question.is_example) {
        return
      }
      if (!this.isExamMode) {
        return
      }
      let inputText = e.replace(/\ +/g, '')
      inputText = inputText.replace(/[\r\n]/g, '')
      let ansObj = {
        questionId: this.currItem.index,
        answer: inputText,
        judge: 0,
        scores: null,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        topic_type: this.currItem.topic_type,
      }
      //选中后延时1ms再提交
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
    },
    handlerSubmit(e) {
      let ansObj = {
        questionId: this.currItem.index,
        answer: e,
        judge: 0,
        scores: null,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        topic_type: this.currItem.topic_type,
      }
      //选中后延时1ms再提交
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
    },
    inputting() {},
  },
}
</script>

<style lang="scss" scoped>
.panel-content {
  width: 100%;
  padding: 30px 29px 20px 29px;
  position: relative;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  &-artical {
    margin: 20px 0 30px;
    p {
      font-size: 16px;
      color: #393d46;
      margin-bottom: 5px;
      text-indent: 2em;
    }
  }
  &-questions {
    margin-bottom: 40px;
    position: relative;
    .question-item-con {
      margin-bottom: 20px;
      position: relative;
    }
    .question-item-stem {
      display: flex;
      margin-bottom: 16px;
      align-items: flex-start;
      font-size: 16px;
    }
    .stem-index {
      width: 25px;
      margin-right: 7px;
      color: #c4c9d3;
    }
    .stem-text {
      line-height: 19px;
    }
    .limit {
      position: absolute;
      bottom: 5px;
      right: 5px;

      font-size: 12px;
      font-weight: 400;
      color: #c6cad4;
    }
    .limit-all {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
    .inputTitle {
      margin-bottom: 20px;
    }
    .show-result {
      .title {
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #393d46;
        margin-bottom: 20px;
      }
      .text {
        font-size: 14px;
        font-weight: 400;
        color: #3e4651;
        line-height: 25px;
        // text-indent: 2em;
      }
    }
  }
  .input-box {
    padding: 5px 15px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    font-size: 14px;
    line-height: 21px;
    min-height: 50px;
    margin-top: 20px;
  }
  .mark-score-con {
    position: absolute;
    top: 0px;
    right: 0px;
  }
  &-result {
    width: 100%;
    // border-top: 1px dashed #f2f3f7;
    border-bottom: 1px solid #e6eaef;
    padding: 20px 0px;
    margin-bottom: 30px;
    .correct-answer {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
    }
    .orange {
      font-size: 14px;
      font-weight: 500;
      color: #fc5a5a;
      margin-bottom: 20px;
    }
  }
  .correct-box {
    background: rgba(251, 252, 255, 1);
    border: 1px solid rgba(242, 243, 247, 1);
    border-radius: 10px;
    padding: 20px;

    &-title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(63, 70, 81, 1);
      margin-bottom: 10px;
    }
    &-answer {
      font-size: 14px;
      font-weight: 400;
      color: rgba(84, 89, 97, 1);
      line-height: 21px;
      white-space: pre-line;
    }
  }
}
</style>
